(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CUSTOMhero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[id^="Hero-"][data-slide-count]');
    if (!section) return;

    const track = section.querySelector('[data-carousel-track]');
    const slides = track ? track.querySelectorAll('.hero-carousel__slide') : [];
    const dots = section.querySelectorAll('.hero-carousel__dot');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');

    if (slides.length <= 1) return;

    const autoplay = section.dataset.autoplay === 'true';
    const interval = parseInt(section.dataset.interval, 10) || 7000;
    let current = 0;
    let timer = null;
    let paused = false;

    function goTo(index) {
      const count = slides.length;
      const next = ((index % count) + count) % count;

      slides[current].classList.remove('hero-carousel__slide--active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('hero-carousel__dot--active');
        dots[current].setAttribute('aria-selected', 'false');
        /* Reset fill animation */
        const fill = dots[current].querySelector('.hero-carousel__dot-fill');
        if (fill) { fill.style.animation = 'none'; fill.offsetHeight; fill.style.animation = ''; }
      }

      slides[next].classList.add('hero-carousel__slide--active');
      slides[next].setAttribute('aria-hidden', 'false');
      if (dots[next]) {
        dots[next].classList.add('hero-carousel__dot--active');
        dots[next].setAttribute('aria-selected', 'true');
        /* Restart fill animation */
        const fill = dots[next].querySelector('.hero-carousel__dot-fill');
        if (fill) { fill.style.animation = 'none'; fill.offsetHeight; fill.style.animation = ''; }
      }

      current = next;
      resetTimer();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function resetTimer() {
      clearInterval(timer);
      if (autoplay && !paused) {
        timer = setInterval(next, interval);
      }
    }

    /* Arrow buttons */
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); });

    /* Dot buttons */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.dotIndex, 10));
      });
    });

    /* Pause on hover/focus */
    section.addEventListener('mouseenter', function () { paused = true; clearInterval(timer); });
    section.addEventListener('mouseleave', function () { paused = false; resetTimer(); });
    section.addEventListener('focusin', function () { paused = true; clearInterval(timer); });
    section.addEventListener('focusout', function () { paused = false; resetTimer(); });

    /* Keyboard nav */
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); }
      if (e.key === 'ArrowRight') { next(); }
    });

    /* Swipe support */
    let touchStartX = 0;
    section.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    section.addEventListener('touchend', function (e) {
      const diff = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(diff) > 50) {
        if (diff < 0) next();
        else prev();
      }
    }, { passive: true });

    /* Start autoplay */
    if (autoplay) {
      timer = setInterval(next, interval);
    }

    /* Visibility API – pause when tab hidden */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearInterval(timer);
      } else if (autoplay && !paused) {
        resetTimer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
